import { takeEvery, call, put } from "redux-saga/effects";
import { GET_LISTDATA, SET_LISTDATA } from "../actions";
import api from "../utils/axios";
export const watchGetListData = function* () {
  yield takeEvery(GET_LISTDATA, workerGetListData);
};

function* workerGetListData(reqData) {
  try {
    const { url, params } = reqData.datas;
    const uri = `${url}?${params || ""}`;

    // Use your axios instance (api)
    const result = yield call(api.get, uri);
    
    // Process and store result
    yield put({ type: SET_LISTDATA, value: [result.data] });
  } catch (e) {
    console.error("API error:", e);
    const returnError = e?.response?.data || [];
    yield put({ type: SET_LISTDATA, value: [returnError] });
  }
}
